<template>
  <div
    class="form-group"
    :class="{
      'form-group--has-error': localError,
      'form-group--has-success': !localError && touched,
    }"
  >
    <label :for="id">
      {{ label }}
      <span v-if="info" class="form-group__info" v-tippy="{ content: info }">
        <BaseIcon name="info" size="14" />
      </span>
    </label>
    <input
      :type="type"
      :id="id"
      :value="modelValue"
      :placeholder="placeholder"
      :inputmode="inputmode"
      @input="handleInput"
      @blur="handleBlur"
      ref="inputRef"
      :disabled="disabled"
      :min="min"
      :max="max"
      :step="step"
    />
    <span v-if="localError" class="form-group__error">{{ localError }}</span>
  </div>
</template>

<script>
  import { ref, watch, onMounted } from 'vue';
  import { validateInput } from '@/utils/validation';
  import BaseIcon from '@/components/partials/BaseIcon.vue';

  export default {
    components: {
      BaseIcon,
    },
    props: {
      id: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      modelValue: {
        type: [String, Number],
        required: true,
      },
      error: {
        type: String,
        default: '',
      },
      rules: {
        type: Array,
        default: () => [],
      },
      realTimeValidation: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'number',
      },
      placeholder: {
        type: String,
        default: '',
      },
      inputmode: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      info: {
        type: String,
        default: null,
      },
      min: {
        type: [Number, String],
        default: undefined,
      },
      max: {
        type: [Number, String],
        default: undefined,
      },
      step: {
        type: [Number, String],
        default: undefined,
      },
    },
    emits: ['update:modelValue', 'validate', 'blur'],
    setup(props, { emit }) {
      const localError = ref(props.error);
      const touched = ref(false);

      const handleInput = (event) => {
        emit('update:modelValue', event.target.value);
      };
      const handleBlur = () => {
        touched.value = true;
        emit('blur');
      };

      const validate = () => {
        const errorMessage = validateInput(props.modelValue, props.rules);
        localError.value = errorMessage;
        emit('validate', errorMessage);
      };

      watch(
        () => props.error,
        (newError) => {
          localError.value = newError;
        },
        { immediate: true }
      );

      return {
        handleInput,
        handleBlur,
        validate,
        localError,
      };
    },
  };
</script>

<style scoped></style>
